import { callBackendApi } from "../../../components/service/axios";

export const fetchAppList = async () => {
  return await callBackendApi("get", "/bff/apps");
};

export const fetchSignedUrlForDownload = async (fileNameSpace, fileCategoryName, fileName) => {
  return await callBackendApi("get", "/bff/gcs/download-url", null, {
    fileNameSpace: fileNameSpace,
    fileCategoryName: fileCategoryName,
    fileName: fileName
  });
};

export const submitFileVerification = async (appId, isAccepted, comment) => {
  return await callBackendApi(
    "put",
    `/bff/review-management/applications/${appId}/files/verify`,
    {
      isAccepted: isAccepted,
      comments: comment
    });
};

export const getLatestFileComments = async (appId) => {
  return await callBackendApi(
    "get",
    `/bff/review-management/applications/${appId}/uploaded-files/comments`
  )
};

export const startNewReview = async (appId) => {
  return await callBackendApi(
    "post",
    `/bff/review-management/applications/${appId}/review/new`
  )
};

export const updateAccessTypeLink = async (appId, link) => {
  return await callBackendApi("patch", `/bff/apps/${appId}/access-type-link`, {
    accessTypeLink: link,
  });
};